"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CustomisedItemCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _customisedItemModule = _interopRequireDefault(require("./customisedItem.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CustomisedItemCard = exports.CustomisedItemCard = /*#__PURE__*/function (_Component) {
  function CustomisedItemCard() {
    var _this;
    _classCallCheck(this, CustomisedItemCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CustomisedItemCard, [].concat(args));
    _defineProperty(_this, "image", new Image());
    _defineProperty(_this, "state", {
      image: {
        width: 0,
        height: 0
      },
      customisation: {
        width: "auto",
        height: "auto",
        x: 0,
        y: 0
      }
    });
    return _this;
  }
  _inherits(CustomisedItemCard, _Component);
  return _createClass(CustomisedItemCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.image.onload = this.setImage.bind(this);
      this.image.src = this.props.itemFile;
    }
  }, {
    key: "setImage",
    value: function setImage() {
      var sizeMultiplier = this.getSizeMultiplier();
      this.setState({
        image: {
          width: this.image.width * sizeMultiplier,
          height: this.image.height * sizeMultiplier
        },
        customisation: {
          width: this.props.customisationWidth * sizeMultiplier,
          x: this.props.customisationX * sizeMultiplier,
          y: this.props.customisationY * sizeMultiplier
        }
      });
    }
  }, {
    key: "getSizeMultiplier",
    value: function getSizeMultiplier() {
      var containerWidth = this.getContainerWidth();
      return containerWidth / this.image.width;
    }
  }, {
    key: "getContainerWidth",
    value: function getContainerWidth() {
      if (this.props.width === "auto") {
        return this.image.width;
      }
      return this.props.width;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "customised-item-card",
        className: _customisedItemModule["default"].container,
        style: {
          width: this.state.image.width,
          height: this.state.image.height
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _customisedItemModule["default"].customisation,
        style: {
          width: this.state.image.width,
          height: this.state.image.height,
          left: -(this.state.image.width / 2),
          right: -(this.state.image.width / 2)
        }
      }, /*#__PURE__*/_react["default"].createElement("object", {
        width: this.state.customisation.width,
        style: {
          width: this.state.customisation.width,
          left: this.state.customisation.x,
          top: this.state.customisation.y
        },
        data: this.props.customisationFile
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _customisedItemModule["default"].item,
        style: {
          width: this.state.image.width,
          height: this.state.image.height,
          left: -(this.state.image.width / 2),
          right: -(this.state.image.width / 2),
          backgroundImage: "url(".concat(this.props.itemFile, ")")
        }
      }));
    }
  }]);
}(_react.Component);
CustomisedItemCard.propTypes = {
  customisationFile: _propTypes["default"].string,
  customisationWidth: _propTypes["default"].number,
  customisationX: _propTypes["default"].number,
  customisationY: _propTypes["default"].number,
  itemFile: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
CustomisedItemCard.defaultProps = {
  customisationFile: "./images/logoSample.png",
  customisationWidth: 0,
  customisationX: 0,
  customisationY: 0,
  itemFile: "",
  width: "auto",
  height: "auto"
};
var _default = exports["default"] = CustomisedItemCard;